<div style="min-height: 100vh;">
  <router-outlet></router-outlet>
</div>
